import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=f6dd992e&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=f6dd992e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dd992e",
  null
  
)

export default component.exports